import { cqAPI, getBid } from "../../lib/Auth";
import {
  Box,
  Flex,
  useColorMode,
  useToast,
  Button,
  Text,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Menu
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { AddIcon } from "@chakra-ui/icons";
import EditableText from "../EditableText/EditableText";
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import HistorySettingsControls from "./HistorySettingsControls";

function History() {
  const toast = useToast();
  const bid = getBid();
  const [templates, setTemplates] = useState([]);
  const [archived, setArchived] = useState([]);
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  const fetchHistoryTemplate = async () => {
    const response = await cqAPI.get("/settings/history");
    setTemplates(response.data);
    setArchived(response.data.filter(t => t.archived).sort((a, b) => a.name.localeCompare(b.name)))
  };

  useEffect(() => {
    fetchHistoryTemplate();
  }, []);

  const updateTemplateField = async (template, field, value) => {
    const response = await cqAPI.put("/settings/history", {
      template_id: template._id,
      field,
      value,
    });
    if (response.type === "error") {
      if (response.msg) {
        toast({
          title: "Error updating the template.",
          description: response.msg,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
      return false;
    }
    await fetchHistoryTemplate();
    return true;
  };

  return (
    <Box
      p={0}
      width="100%"
      position="relative"
    >
      <Flex
        p={4}
        padding="8px 24px 24px 24px"
        bgColor={colorMode === "light" ? "#FFFFFF" : "#212330"}
        borderRadius="16px"
        flexDirection="column"
      >
        <Flex justifyContent="flex-end" mb={4}>
          <Button leftIcon={<AddIcon />} onClick={()=>{
            const newSearchParams = new URLSearchParams(
              window.location.search
            );
            navigate(`/settings/history/new?${newSearchParams.toString()}`)
          }}>Add Questionnaire</Button>
        </Flex>
        {templates.map((template, index) => (
          !template.archived &&
          <Box
            className="template"
            key={template._id || "default"}
            mb="4"
            padding="16px 24px 16px 24px"
            bgColor={colorMode === "light" ? "gray.100" : "gray.700"}
            borderRadius="md"
          >
            <Flex flexDirection="column" gap={2}>
            <Flex flex="1" gap={2} flexDirection="row" alignItems="center">
              <Flex width="300px" align="center">
                <EditableText
                  onSave={(newValue) =>
                    updateTemplateField(template, "name", newValue)
                  }
                  initialValue={template.name}
                  placeholder="Name"
                  editable={template.bid === bid}
                  pattern={/[^\ ]{3,}/}
                  invalid="more than 3 character."
                />
              </Flex>
              <Flex justifyContent="flex-end" ml={'auto'}>
                <Menu>
                  <MenuButton as={IconButton} aria-label="Options" icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                              variant="ellipsis"/>
                  <MenuList>
                    <MenuItem onClick={() => {
                      const newSearchParams = new URLSearchParams(
                        window.location.search
                      );
                      navigate(`/settings/history/${template._id}?${newSearchParams.toString()}`)
                    }}>
                      Edit
                    </MenuItem>
                    <MenuItem onClick={async () => {
                      await updateTemplateField(template, "archived", true)
                    }}>
                      Archive
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>
              <HistorySettingsControls
                template={template}
                updateTemplateField={updateTemplateField}
              />
            {template.updated && <Flex fontSize="14px">Updated: {moment(template.updated).format("L")}</Flex>}
          </Flex>
          </Box>
        ))}


      {archived &&
        <Flex gap={4} mt={8} mb={4}>
          <Text fontSize="lg" fontWeight="bold">Archived</Text>
        </Flex>
      }

      {archived.map((template, index) => (
        <Box
          p={0}
          className="template"
          key={template._id || "default"}
          mb="4"
          padding="16px 24px 16px 24px"
          bgColor={colorMode === "light" ? "gray.100" : "gray.700"}
          borderRadius="md"
          width="100%"
          position="relative"
        >
          <Flex flexDirection="column" p={0}>
            <Flex flex="1" gap={2} flexDirection="row" alignItems="center">
              <Flex width="300px" align="center">
                <EditableText
                  onSave={(newValue) =>
                    updateTemplateField(template, "name", newValue)
                  }
                  initialValue={template.name}
                  placeholder="Name"
                  editable={template.bid === bid}
                  pattern={/[^\ ]{3,}/}
                  invalid="more than 3 character."
                />
              </Flex>
              <Flex justifyContent="flex-end" ml={'auto'}>
                <Menu>
                  <MenuButton as={IconButton} aria-label="Options" icon={<FontAwesomeIcon icon={faEllipsisV}/>}
                              variant="ellipsis"/>
                  <MenuList>
                    <MenuItem onClick={async () => {
                      await updateTemplateField(template, "archived", false)
                    }}>
                      Unarchive
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
            </Flex>
          </Flex>
      </Box>
      ))}
      </Flex>
    </Box>
  );
}

export default History;
